import { z } from "zod";

import type { AddUserFormData } from "./add-user-schema";

const fieldErrorsSchema = z.object({
  response: z.object({
    data: z.object({
      error: z.object({
        fields: z.record(z.string(), z.array(z.string())),
      }),
    }),
  }),
});

export const parseFieldErrors = (
  error: unknown,
): Partial<Record<keyof AddUserFormData, string>> => {
  const parsed = fieldErrorsSchema.safeParse(error);

  if (!parsed.success) return {};

  const fields = parsed.data.response.data.error.fields;

  return (["firstName", "lastName", "email"] as const).reduce<
    Partial<Record<keyof AddUserFormData, string>>
  >((accumulator, field) => {
    const message = fields[field]?.[0];

    if (message) accumulator[field] = message;

    return accumulator;
  }, {});
};
